import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const Pagination = ({ pageContext }) => {
    const { previousPagePath, nextPagePath, humanPageNumber, numberOfPages } = pageContext

    return (
        <nav className="pagination" role="navigation" style={{
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div>
                {previousPagePath && (

                    <Link to={previousPagePath} rel="prev" style={{
                        fontFamily: 'merriweather_light',
                        textDecoration: 'none',
                        marginRight: '14px',
                        fontSize: '26px',
                        color: 'hsla(0, 0%, 0%, 0.8)',
                        border: '1px solid hsla(0, 0%, 0%, 0.8)',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        display: 'block',
                        padding: '7px'
                    }}>
                            {'←'}
                    </Link>

                )}
            </div>
            {numberOfPages > 1 && <div className="pagination-location" style={{
                        fontFamily: 'merriweather_light',
                        textDecoration: 'none'
                    }}>Pagina <span style={{fontStyle: 'italic', fontWeight: 'bold'}}>{humanPageNumber}</span> di <span style={{fontStyle: 'italic', fontWeight:'bold'}}>{numberOfPages}</span></div>}
            <div>
                {nextPagePath && (

                    <Link to={nextPagePath} rel="next" style={{
                        fontFamily: 'merriweather_light',
                        textDecoration: 'none',
                        marginLeft: '14px',
                        fontSize: '26px',
                        color: 'hsla(0, 0%, 0%, 0.8)',
                        border: '1px solid hsla(0, 0%, 0%, 0.8)',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        display: 'block',
                        padding: '7px'
                    }}>
                            {'→'}
                    </Link>
                )}
            </div>
        </nav>
    )
}

Pagination.propTypes = {
    pageContext: PropTypes.object.isRequired,
}

export default Pagination